import axios from "axios";
import { inject, injectable } from "inversify";
import { IPipelineRepository } from "@domain/repositories";
import { Pipeline, Step } from "@domain/schemas/BI";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

@injectable()
export class PipelineRepository implements IPipelineRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  async getAsync(id: string): Promise<Pipeline> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.pipelinesId}`.replace("{id}", () => id);
    return this._requestHandlerService.handleRequestAsync<Pipeline>(() => axios.get<Pipeline>(url));
  }

  async getStepsAsync(pipelineId: string): Promise<Step[]> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.pipelineSteps}`.replace("{pipeline_id}", () => pipelineId);
    return this._requestHandlerService.handleRequestAsync<Step[]>(() => axios.get<Step[]>(url));
  }
}
